module.exports = __webpack_public_path__ + "static/media/RegenciaQuimicaPic.fe84fc8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/RegenciaQuimicaPic.png
// module id = 111
// module chunks = 0